import SortableTable from 'app/agriculture/components/Table/SortableTable';
import { useRouteActions } from 'app/agriculture/router/useRouteActions';
import { useMemo } from 'react';
import { Button } from 'app/agriculture/components/Button/Button';
import { DeviceIcon } from 'app/agriculture/icons/devices/DeviceIcon';
import { primaryColourMain } from 'app/agriculture/material';
import { DeviceDetailContext } from 'app/agriculture/routes/Devices/DeviceDetails/context/DeviceDetailContextProvider';
import { DeviceStatusProvider } from 'app/agriculture/routes/Devices/utils/status/DeviceStatusContext';
import { StatHealth } from 'app/agriculture/components/StatHealth/StatHealth';
import { Device } from 'app/agriculture/queries/devices/types/Device';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { DeviceFlyToButton } from 'app/agriculture/routes/Devices/components/DeviceFlyToButton';

interface DeviceListTableProps {
    devices: Device[];
    disableSort?: boolean;
    onSort?: () => void;
}

export function DeviceListTable({
    devices,
    disableSort = false,
    onSort = () => {
        /* do nothing */
    },
}: DeviceListTableProps) {
    const routeActions = useRouteActions();

    const deviceData = useMemo(
        () =>
            devices.map((device) => {
                const { id, name, deviceType } = device;

                return {
                    id,
                    name: {
                        value: name,
                        display: (
                            <div className="DeviceList__name">
                                <SuspenseWrapper loadingComponent={null}>
                                    <DeviceFlyToButton deviceId={id} />
                                </SuspenseWrapper>
                                <Button
                                    variant="compact"
                                    onClick={() => {
                                        routeActions.goto(id, { type: 'Device' });
                                    }}
                                    text={name}
                                    className="DeviceList__button"
                                />
                            </div>
                        ),
                    },
                    type: {
                        value: deviceType,
                        display: (
                            <DeviceIcon
                                deviceType={deviceType}
                                title={deviceType}
                                size={20}
                                color={primaryColourMain}
                            />
                        ),
                    },
                    status: {
                        value: '',
                        display: (
                            <DeviceDetailContext.Provider value={{ device }}>
                                <DeviceStatusProvider deviceId={device.id}>
                                    <StatHealth hideLabel />
                                </DeviceStatusProvider>
                            </DeviceDetailContext.Provider>
                        ),
                    },
                };
            }),
        [devices, routeActions],
    );

    return (
        <SortableTable
            button={({ id }) => ({
                text: 'Edit',
                onClick: () => {
                    routeActions.edit(id, { type: 'Device' });
                },
                startIcon: 'edit',
                variant: 'compact',
            })}
            data={deviceData}
            headCells={[
                { key: 'name', label: 'Name' },
                { key: 'type', label: 'Type' },
                { key: 'status', label: 'Status' },
            ]}
            defaultSort={{ key: 'name', order: 'asc' }}
            disableSort={disableSort}
            onSort={onSort}
        />
    );
}
